// export const flag = (
//   <svg
//     width="16"
//     height="16"
//     viewBox="0 0 16 16"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M2.66667 3.33334C2.66668 3.24468 2.68438 3.15692 2.71872 3.07519C2.75306 2.99346 2.80336 2.9194 2.86667 2.85734C3.59323 2.1451 4.5639 1.73649 5.58111 1.71469C6.59831 1.6929 7.5856 2.05954 8.342 2.74001L8.57601 2.95867C9.06229 3.38474 9.68681 3.61962 10.3333 3.61962C10.9799 3.61962 11.6044 3.38474 12.0907 2.95867L12.2567 2.80734C12.6633 2.48534 13.2747 2.74267 13.33 3.258L13.3333 3.33334V9.33334C13.3333 9.42199 13.3156 9.50975 13.2813 9.59149C13.2469 9.67322 13.1967 9.74728 13.1333 9.80934C12.4068 10.5216 11.4361 10.9302 10.4189 10.952C9.4017 10.9738 8.41441 10.6071 7.65801 9.92667L7.42401 9.708C6.95303 9.29534 6.35185 9.06158 5.72582 9.04768C5.09978 9.03379 4.48883 9.24064 4.00001 9.632V14C3.99982 14.1699 3.93475 14.3334 3.81811 14.4569C3.70146 14.5805 3.54204 14.6548 3.37241 14.6648C3.20278 14.6747 3.03575 14.6196 2.90545 14.5105C2.77515 14.4014 2.69141 14.2467 2.67134 14.078L2.66667 14V3.33334Z"
//       fill="currentColor"
//     />
//   </svg>
// );

export const flag = (
  <svg
    width="19"
    height="19"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.91669 10.25C2.91669 10.25 3.58335 9.58333 5.58335 9.58333C7.58335 9.58333 8.91669 10.9167 10.9167 10.9167C12.9167 10.9167 13.5834 10.25 13.5834 10.25V2.25C13.5834 2.25 12.9167 2.91667 10.9167 2.91667C8.91669 2.91667 7.58335 1.58333 5.58335 1.58333C3.58335 1.58333 2.91669 2.25 2.91669 2.25V10.25Z"
      stroke="currentColor"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.91669 14.9167V10.25"
      stroke="currentColor"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const fileIcon = (
  <svg
    width="23"
    height="23"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.83335 14.8333H10.6667V12.3333H13.1667V11.5H10.6667V9H9.83335V11.5H7.33335V12.3333H9.83335V14.8333ZM4.41669 17.75V2.75H12.3334L16.0834 6.5V17.75H4.41669ZM11.9167 6.91667H15.25L11.9167 3.58333V6.91667Z"
      fill="#99A1AF"
    />
  </svg>
);

export const eyeIcon = (
  <svg
    width="26"
    height="25"
    viewBox="0 0 26 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5688 13.7241C13.5359 13.7241 14.32 12.94 14.32 11.9728C14.32 11.0057 13.5359 10.2216 12.5688 10.2216C11.6016 10.2216 10.8175 11.0057 10.8175 11.9728C10.8175 12.94 11.6016 13.7241 12.5688 13.7241Z"
      fill="#4B5563"
      fill-opacity="0.65"
    />
    <path
      d="M19.1079 11.8262C18.593 10.4942 17.699 9.34229 16.5366 8.51284C15.3741 7.6834 13.994 7.21276 12.567 7.15909C11.14 7.21276 9.75992 7.6834 8.59745 8.51284C7.43497 9.34229 6.54102 10.4942 6.02608 11.8262C5.99131 11.9224 5.99131 12.0277 6.02608 12.1239C6.54102 13.4559 7.43497 14.6078 8.59745 15.4372C9.75992 16.2667 11.14 16.7373 12.567 16.791C13.994 16.7373 15.3741 16.2667 16.5366 15.4372C17.699 14.6078 18.593 13.4559 19.1079 12.1239C19.1427 12.0277 19.1427 11.9224 19.1079 11.8262ZM12.567 14.8208C12.0042 14.8208 11.454 14.6539 10.986 14.3412C10.518 14.0285 10.1532 13.5841 9.93784 13.0641C9.72245 12.5441 9.66609 11.9719 9.7759 11.4198C9.8857 10.8678 10.1567 10.3608 10.5547 9.96276C10.9527 9.56476 11.4598 9.29374 12.0118 9.18392C12.5638 9.07413 13.136 9.13048 13.656 9.34587C14.176 9.56126 14.6205 9.92601 14.9332 10.394C15.2459 10.862 15.4128 11.4122 15.4128 11.975C15.4116 12.7294 15.1114 13.4526 14.578 13.986C14.0446 14.5195 13.3214 14.8196 12.567 14.8208Z"
      fill="#4B5563"
      fill-opacity="0.65"
    />
  </svg>
);

export const completedIcon = (
  <svg
    width="13"
    height="13"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_8089_16583)">
      <path
        d="M10.2944 1.59527C10.3596 1.66491 10.4113 1.74765 10.4465 1.83874C10.4819 1.92983 10.5 2.02748 10.5 2.12609C10.5 2.22471 10.4819 2.32236 10.4465 2.41346C10.4113 2.50455 10.3596 2.58728 10.2944 2.65692L3.99567 9.40473C3.93066 9.47455 3.85343 9.52997 3.7684 9.56778C3.68338 9.60558 3.59223 9.625 3.50017 9.625C3.40812 9.625 3.31696 9.60558 3.23194 9.56778C3.14692 9.52997 3.06968 9.47455 3.00467 9.40473L0.205242 6.40571C0.0738278 6.26493 0 6.07397 0 5.87488C0 5.67578 0.0738278 5.48484 0.205242 5.34405C0.336657 5.20327 0.514894 5.12418 0.700742 5.12418C0.88659 5.12418 1.06483 5.20327 1.19624 5.34405L3.50017 7.81375L9.30338 1.59527C9.3684 1.52545 9.44565 1.47005 9.53063 1.43225C9.61567 1.39446 9.7068 1.375 9.7989 1.375C9.89092 1.375 9.98213 1.39446 10.0671 1.43225C10.1522 1.47005 10.2294 1.52545 10.2944 1.59527Z"
        fill="#16A34A"
      />
    </g>
    <defs>
      <clipPath id="clip0_8089_16583">
        <rect
          width="10.5"
          height="10.5"
          fill="white"
          transform="translate(0 0.25)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const cancelIcon = (
  <svg
    width="13"
    height="13"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.726562 8.75L4.72653 4.74999M4.72653 4.74999L8.72656 8.75M4.72653 4.74999L8.72656 0.75M4.72653 4.74999L0.726562 0.75"
      stroke="#E7000B"
      stroke-width="0.7875"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const userIcon = (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.75 7.5C8.75 6.43913 9.17143 5.42172 9.92157 4.67157C10.6717 3.92143 11.6891 3.5 12.75 3.5C13.8109 3.5 14.8283 3.92143 15.5784 4.67157C16.3286 5.42172 16.75 6.43913 16.75 7.5C16.75 8.56087 16.3286 9.57828 15.5784 10.3284C14.8283 11.0786 13.8109 11.5 12.75 11.5C11.6891 11.5 10.6717 11.0786 9.92157 10.3284C9.17143 9.57828 8.75 8.56087 8.75 7.5ZM8.75 13.5C7.42392 13.5 6.15215 14.0268 5.21447 14.9645C4.27678 15.9021 3.75 17.1739 3.75 18.5C3.75 19.2956 4.06607 20.0587 4.62868 20.6213C5.19129 21.1839 5.95435 21.5 6.75 21.5H18.75C19.5456 21.5 20.3087 21.1839 20.8713 20.6213C21.4339 20.0587 21.75 19.2956 21.75 18.5C21.75 17.1739 21.2232 15.9021 20.2855 14.9645C19.3479 14.0268 18.0761 13.5 16.75 13.5H8.75Z"
      fill="#1D2951"
      fill-opacity="0.35"
    />
  </svg>
);
